import { Button } from '@material-ui/core';
import { useParams } from 'react-router';

import { useDialog } from '@/components/shared/hooks/useDialog';
import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';
import { CustomerSupportDialog } from '@/components/widgets/CustomerSupport/components/CustomerSupportDialog/CustomerSupportDialog';

export const CustomerSupport = () => {
  const { loanId } = useParams();
  const { opened, setOpened, toggleDialog } = useDialog();

  if (!loanId) return <></>;
  return (
    <>
      <Button onClick={() => toggleDialog()}>
        <Font variant={'subtitle2'} color={'textSecondary'}>
          <i
            className={'material-icons-outlined mr-2'}
            style={{ verticalAlign: '-5px', marginLeft: '-4px', fontSize: '1.5em' }}
          >
            support_agent
          </i>
          <Text tId={'CUSTOMER_SUPPORT'} />
        </Font>
      </Button>
      {opened && <CustomerSupportDialog loanId={loanId} opened={opened} setOpened={setOpened} />}
    </>
  );
};
